import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
//Material
import Box from "@material-ui/core/Box";
//Component
import { Modal } from "../../stories/modal";
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import Popup from 'reactjs-popup';
import BootstrapTable from 'react-bootstrap-table-next';
import { makeStyles } from '@material-ui/core/styles';
//Function
import { GetListViewHistory,GetListExtendTime } from "./api";
import { getViewHistoryColumns } from "./columns/view-history";
import { GetUser } from "./../../utils/sessions";
import { url, method } from "./signalr";
import { useSignalR } from "./../function-api/useSignalR";
import { UpdateExtendTime } from "./api";
import * as alertDialog from "./../../utils/alert";
import { useSelectItem } from "../../stories/react-table/useSelectItem";
import { Button } from "@material-ui/core";
import { isEmptyArray } from "../../utils/common-function";

const useStyles = makeStyles((theme) => ({
  iconButtonAddDelete: {
    // padding: 10,
    backgroundColor: '#000',
    color: '#fff',
    marginRight: theme.spacing(2),
  },
}));


function ExtendOutbound() {
  //State
  const [DataList, setDataList] = useState([]);
  const [ExtendList, setExtendList] = useState([]);
  const classes = useStyles();
  const { handleOnSelect, handleOnSelectAll, SelectedItems } = useSelectItem(
    "FILE_ID"
  );
  const fetch = async () => {
    let param = { "USER_ID": GetUser()};
    let res = await GetListViewHistory(param);
    setDataList(res);
  }
  const fetchListExtend = async () => {
    let param = { "USER_ID": GetUser()};
    let resExtend = await GetListExtendTime(param);
    setExtendList(resExtend);
  }
  //Effect
  useEffect(() => {
    fetchListExtend();
    fetch();
  }, []);


  const ExtendTime = async (DayExtend) => {
    if (isEmptyArray(SelectedItems)) {
    alertDialog.ErrorDialog("Please Select Item.");
    return;
    }
    console.log(DataList);
    let all = DataList.filter((el) => 
      el.SHOW_EXTEND === 1 ? SelectedItems.includes(el.FILE_ID) : []
    );
    console.log(all);
    const extendTime = async () => { 
      let resConfirm = await alertDialog.ConfirmCommon("Do you want to extend time ?", "Yes", "No");
      if (!resConfirm) return;

      let lstExten = all.filter((x => x.SHOW_EXTEND === 1)).map((x) => {
        return ({"FILE_ID" : x.FILE_ID,"CTL_ID" : x.CTL_ID,"DATE_END" : x.END_DATE,"DAY_EXTEND" : DayExtend})
      });
      let res = await UpdateExtendTime(lstExten);
      if(res?.ResultCode === 10){
        alertDialog.Success();
        setDataList([]);
        fetch();
     }
     else{
       alertDialog.ErrorDialog("Error : "+res.Message);
     }

      handleOnSelectAll(false);
      console.log(SelectedItems);
    }
    
    extendTime();
    
    //console.log(SelectedItems);
    //setOpenModal(true);
    
  }
  const tablecomponent = () => {
    return (
        <>
        {ExtendList.map((x) => {
          return (
            <Button className={classes.iconButtonAddDelete} variant="contained" onClick={() => {
                  ExtendTime(x.INT_VALUE)
                }}>
                {x.LABEL}
            </Button>
          );
        })}
        </>
    );
};
  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Extend Outbound">
          <FormProvider>
          {DataList?.length > 0 ?
            (<ReactTable id="1"
              keyField="ROW_NUMBER"
              data={DataList}
              clickToSelect
              headcomponent={tablecomponent}
              handleOnSelect={handleOnSelect}
              handleOnSelectAll={handleOnSelectAll}
              columns={getViewHistoryColumns()}
              //selectedRow={[461]}
              disableSelectable={DataList?.filter((x => x.SHOW_EXTEND === 0)).map((c) => 
                c.ROW_NUMBER)}
            />) : <BootstrapTable keyField='id' data={ [] } columns={ getViewHistoryColumns() } noDataIndication={ 'No results found' } />}
          </FormProvider>
        </BoxTemplate1>
       
      </BaseContainer>
    </div>
  );
}
export default ExtendOutbound;
